var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.89,99.46l-2.21-3.64C401.06,65.13,367.4,46.64,331.9,48.88a93,93,0,0,0-13.58,1.87c-32.27,6.91-60.35,31.31-72,62.56-6.85,18.38-8.76,39.55-21.75,54.14-16.91,19-45.61,19.58-70.84,18.8s-54-.12-70.78,18.94c-10.54,11.94-13.89,28.92-13,44.91,2.25,42.33,31.75,80.18,69.26,99s81.68,20.5,122.74,12.23c57.51-11.6,112.2-43.44,145.08-92.61S448.2,152.53,421.89,99.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.75,
    cy: 212.94,
    r: 16.64,
    transform: "translate(-139.22 89.77) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.32,
    cy: 58.05,
    r: 16.64,
    transform: "translate(281.81 471.57) rotate(-76.81)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.85,74.66a36.14,36.14,0,0,0-19.73,47.08l22.41,54.7,10-4.11-22.4-54.71a25.23,25.23,0,0,1,46.7-19.12l10.05-4.12A36.12,36.12,0,0,0,75.85,74.66Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.85,74.66a36.14,36.14,0,0,0-19.73,47.08l22.41,54.7,10-4.11-22.4-54.71a25.23,25.23,0,0,1,46.7-19.12l10.05-4.12A36.12,36.12,0,0,0,75.85,74.66Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 65.15,
    y: 136.1,
    width: 97.29,
    height: 62.42,
    rx: 5.81,
    transform: "translate(-54.91 55.6) rotate(-22.27)",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.23,156.7a8.13,8.13,0,1,0-6.62,11.13l4.6,11.25,4.11-1.68-4.61-11.25A8.1,8.1,0,0,0,118.23,156.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.16,207.18c-.21.09-4.32-9.48-9.18-21.36s-8.65-21.58-8.44-21.67,4.32,9.48,9.18,21.37S83.36,207.1,83.16,207.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.76,171.85a2.77,2.77,0,0,1-1.08-.14,10.14,10.14,0,0,1-2.75-1.19,11.38,11.38,0,0,1-2.73-17.36,9.51,9.51,0,0,1,2.25-2c.6-.37,1-.51,1-.47a25.93,25.93,0,0,0-2.8,2.79,11.28,11.28,0,0,0,2.6,16.53A26.35,26.35,0,0,0,108.76,171.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.94,181.71l.49-1.42.93,1.18a6.21,6.21,0,0,0,2.88,2l1.42.49-1.18.93a6.34,6.34,0,0,0-2,2.88L47,189.22,46,188.05a6.31,6.31,0,0,0-2.89-2l-1.41-.49,1.17-.93A6.34,6.34,0,0,0,44.94,181.71Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,125.92l.28-.82.54.68A3.69,3.69,0,0,0,94.9,127l.82.28-.68.55a3.63,3.63,0,0,0-1.19,1.67l-.28.82L93,129.6a3.54,3.54,0,0,0-1.67-1.18l-.83-.29.69-.54A3.68,3.68,0,0,0,92.4,125.92Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.33,132.87l.82-2.39,1.57,2a10.48,10.48,0,0,0,4.84,3.42l2.38.82-2,1.57a10.57,10.57,0,0,0-3.43,4.84l-.82,2.38-1.56-2a10.5,10.5,0,0,0-4.84-3.43l-2.38-.82,2-1.56A10.58,10.58,0,0,0,35.33,132.87Z",
    style: {
      fill: "#3559E0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.06,479.9l-147.61-.09a32.16,32.16,0,0,1-32.14-32.16l.07-370.07a32.16,32.16,0,0,1,32.18-32.15l147.61.08a32.16,32.16,0,0,1,32.14,32.16l-.07,370.08A32.16,32.16,0,0,1,311.06,479.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,58.6H282.4a7.1,7.1,0,0,0-6.95,7.26V71a7.11,7.11,0,0,1-6.95,7.26l-55.78,0a7.12,7.12,0,0,1-7-7.27V65.81a7.11,7.11,0,0,0-6.95-7.27H163.7A22.53,22.53,0,0,0,141.16,81l-.07,361.22a22.52,22.52,0,0,0,22.51,22.52l147.32.09a22.51,22.51,0,0,0,22.53-22.52l.07-361.21A22.52,22.52,0,0,0,311,58.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.63,437.25a2.83,2.83,0,1,1-2.86-2.8A2.84,2.84,0,0,1,223.63,437.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.47,437.12a2.83,2.83,0,1,1-2.85-2.8A2.83,2.83,0,0,1,239.47,437.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.32,437a2.83,2.83,0,1,1-2.85-2.8A2.83,2.83,0,0,1,255.32,437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,95.08c0,.08-3.73.18-8.32.22s-8.31,0-8.31-.09S299,95,303.56,95,311.87,95,311.88,95.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.91,99.33c0,.09-3.72.19-8.31.23s-8.32,0-8.32-.09,3.72-.19,8.32-.23S311.91,99.24,311.91,99.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,103.58c0,.09-3.73.19-8.32.23s-8.31,0-8.31-.09,3.72-.18,8.31-.22S311.94,103.5,312,103.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.65,108.44l.34,0,1,0,3.56-.08-.09.09c0-.78,0-1.64,0-2.57a14.72,14.72,0,0,1,0-1.48,1.33,1.33,0,0,1,1.17-1.08c.57,0,1.08,0,1.7,0a1.35,1.35,0,0,1,1.15,1.35c0,1.2,0,2.46,0,3.76l-.15-.15,4.48,0-.15.15c0-1.8,0-3.67,0-5.58,0-.47,0-1,0-1.42a1.17,1.17,0,0,0-.18-.58,4.13,4.13,0,0,0-.46-.49c-.66-.65-1.31-1.3-2-1.93l-1.89-1.86c-.3-.31-.61-.61-.91-.91s-.56-.62-.94-.69a1.21,1.21,0,0,0-1,.2c-.27.23-.56.55-.83.82l-1.61,1.62c-1,1-2.06,2-2.83,2.92a3.21,3.21,0,0,0-.22,1.68c0,.56,0,1.08,0,1.58,0,1,0,1.82,0,2.54s0,1.2,0,1.63,0,.58,0,.58,0-.18,0-.54,0-1,0-1.6,0-1.58-.05-2.56c0-.51,0-1,0-1.61,0-.29,0-.58,0-.88a1.83,1.83,0,0,1,.25-.93c.83-1,1.82-1.91,2.84-3l1.59-1.63c.29-.28.53-.57.86-.86a1.51,1.51,0,0,1,1.29-.25,2.38,2.38,0,0,1,1.06.76l.92.9,1.9,1.86,2,1.93a3.76,3.76,0,0,1,.5.54,1.5,1.5,0,0,1,.23.74c0,.48,0,1,0,1.43,0,1.91,0,3.78,0,5.58v.15h-.16l-4.48,0h-.14v-.15c0-1.3,0-2.55,0-3.75a1.11,1.11,0,0,0-.92-1.11c-.52,0-1.13,0-1.63,0a1.11,1.11,0,0,0-1,.88c0,.46,0,1,0,1.43,0,.93,0,1.79,0,2.58v.09h-.09l-3.61,0H161A1.64,1.64,0,0,1,160.65,108.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.47,194.2c0,3.47-2.6,5.63-6.76,5.63h-3.13v4.28H185V188.56h6.73C195.87,188.56,198.47,190.72,198.47,194.2Zm-3.65,0c0-1.71-1.11-2.71-3.31-2.71h-2.93v5.4h2.93C193.71,196.89,194.82,195.89,194.82,194.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24,197.29v6.82H208v-1.49a3.93,3.93,0,0,1-3.64,1.67c-2.8,0-4.47-1.55-4.47-3.62s1.49-3.58,5.13-3.58h2.76c0-1.49-.89-2.35-2.76-2.35a5.73,5.73,0,0,0-3.44,1.11l-1.25-2.42a9.18,9.18,0,0,1,5.16-1.45C209.13,192,211.24,193.67,211.24,197.29Zm-3.46,3.05v-1.22H205.4c-1.62,0-2.13.59-2.13,1.39S204,202,205.22,202A2.55,2.55,0,0,0,207.78,200.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.22,203l1.16-2.49a8.12,8.12,0,0,0,4.15,1.16c1.6,0,2.2-.42,2.2-1.09,0-2-7.22,0-7.22-4.73,0-2.27,2-3.87,5.53-3.87a9.76,9.76,0,0,1,4.6,1.05l-1.15,2.46a7,7,0,0,0-3.45-.89c-1.55,0-2.22.49-2.22,1.12,0,2,7.22.06,7.22,4.77,0,2.22-2.07,3.8-5.64,3.8A10.21,10.21,0,0,1,213.22,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,203l1.15-2.49a8.19,8.19,0,0,0,4.16,1.16c1.6,0,2.2-.42,2.2-1.09,0-2-7.22,0-7.22-4.73,0-2.27,2-3.87,5.53-3.87a9.79,9.79,0,0,1,4.6,1.05l-1.16,2.46a6.9,6.9,0,0,0-3.44-.89c-1.56,0-2.22.49-2.22,1.12,0,2,7.22.06,7.22,4.77,0,2.22-2.07,3.8-5.64,3.8A10.18,10.18,0,0,1,225,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.94,192.16l-4.33,12h-3.33l-2.69-7.42-2.78,7.42h-3.33l-4.31-12h3.27l2.82,8.09,2.93-8.09h2.93l2.85,8.09,2.91-8.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.35,198.14c0-3.6,2.77-6.16,6.57-6.16s6.56,2.56,6.56,6.16-2.76,6.15-6.56,6.15S257.35,201.74,257.35,198.14Zm9.62,0a3.06,3.06,0,1,0-3.05,3.31A3,3,0,0,0,267,198.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.21,192v3.2c-.29,0-.51,0-.78,0-1.91,0-3.18,1-3.18,3.33v5.64h-3.46v-12h3.31v1.58A4.8,4.8,0,0,1,280.21,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,187.63v16.48H291v-1.37a4.61,4.61,0,0,1-3.73,1.55,6.16,6.16,0,0,1,0-12.31,4.57,4.57,0,0,1,3.57,1.45v-5.8Zm-3.4,10.51a3.06,3.06,0,1,0-3,3.31A3,3,0,0,0,290.94,198.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,217c0,.14-37,.26-82.69.26s-82.71-.12-82.71-.26,37-.26,82.71-.26S321,216.83,321,217Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.15,369.23c0,.15-37,.26-82.7.26s-82.7-.11-82.7-.26,37-.26,82.7-.26S317.15,369.09,317.15,369.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.74,380.67c0,.14-20.57.26-45.94.26s-45.94-.12-45.94-.26,20.56-.26,45.94-.26S279.74,380.52,279.74,380.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5,261.3l3.13,1.69-1.41,2.36-3.16-1.87.06,3.48h-2.7l0-3.51-3.17,1.9L161.9,263,165,261.3l-3.14-1.73,1.38-2.35,3.17,1.89,0-3.5h2.7l-.06,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.42,261.3l3.13,1.69-1.41,2.36L205,263.48,205,267h-2.71l0-3.51-3.16,1.9L197.82,263,201,261.3l-3.13-1.73,1.38-2.35,3.16,1.89,0-3.5H205l-.06,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.38,261.3l3.13,1.69-1.41,2.36-3.16-1.87L240,267h-2.7l0-3.51-3.17,1.9L232.78,263l3.14-1.69-3.14-1.73,1.38-2.35,3.17,1.89,0-3.5H240l-.06,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.25,261.3l3.13,1.69L277,265.35l-3.16-1.87.06,3.48h-2.7l0-3.51-3.16,1.9L266.65,263l3.14-1.69-3.14-1.73,1.38-2.35,3.16,1.89,0-3.5h2.7l-.06,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.85,261.3,312,263l-1.41,2.36-3.16-1.87.05,3.48h-2.7l0-3.51-3.16,1.9L300.26,263l3.13-1.69-3.13-1.73,1.38-2.35,3.16,1.89,0-3.5h2.7l-.05,3.5,3.16-1.89,1.41,2.35Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.07,283.08H160.92a7.08,7.08,0,0,1-7.07-7.07v-26.9a7.07,7.07,0,0,1,7.07-7.06h15.15a7.07,7.07,0,0,1,7.07,7.06V276A7.08,7.08,0,0,1,176.07,283.08Zm-15.15-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.58,6.58,0,0,0,6.57,6.57h15.15a6.57,6.57,0,0,0,6.57-6.57v-26.9a6.57,6.57,0,0,0-6.57-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,283.08H196.11A7.08,7.08,0,0,1,189,276v-26.9a7.07,7.07,0,0,1,7.07-7.06h15.15a7.07,7.07,0,0,1,7.07,7.06V276A7.08,7.08,0,0,1,211.26,283.08Zm-15.15-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.58,6.58,0,0,0,6.57,6.57h15.15a6.57,6.57,0,0,0,6.57-6.57v-26.9a6.57,6.57,0,0,0-6.57-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.49,283.08H230.33a7.08,7.08,0,0,1-7.07-7.07v-26.9a7.07,7.07,0,0,1,7.07-7.06h15.16a7.07,7.07,0,0,1,7.06,7.06V276A7.07,7.07,0,0,1,245.49,283.08Zm-15.16-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.58,6.58,0,0,0,6.57,6.57h15.16a6.57,6.57,0,0,0,6.56-6.57v-26.9a6.56,6.56,0,0,0-6.56-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1,283.08H264.94a7.08,7.08,0,0,1-7.07-7.07v-26.9a7.07,7.07,0,0,1,7.07-7.06H280.1a7.07,7.07,0,0,1,7.06,7.06V276A7.07,7.07,0,0,1,280.1,283.08Zm-15.16-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.58,6.58,0,0,0,6.57,6.57H280.1a6.57,6.57,0,0,0,6.56-6.57v-26.9a6.56,6.56,0,0,0-6.56-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7,283.08H298.55a7.08,7.08,0,0,1-7.07-7.07v-26.9a7.07,7.07,0,0,1,7.07-7.06H313.7a7.07,7.07,0,0,1,7.07,7.06V276A7.08,7.08,0,0,1,313.7,283.08Zm-15.15-40.53a6.57,6.57,0,0,0-6.57,6.56V276a6.57,6.57,0,0,0,6.57,6.57H313.7a6.58,6.58,0,0,0,6.57-6.57v-26.9a6.57,6.57,0,0,0-6.57-6.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.09,
    y: 315.56,
    width: 169.79,
    height: 29.74,
    rx: 11.29,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.55,324.45h4.57c3.29,0,5.55,2,5.55,5s-2.26,5-5.55,5h-4.57ZM222,332.6a3.12,3.12,0,1,0,0-6.24h-2.13v6.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.69,330.65a4.26,4.26,0,1,1,4.26,4A4,4,0,0,1,228.69,330.65Zm6.23,0a2,2,0,1,0-4,0,2,2,0,1,0,4,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.59,330.09v4.42h-2.24v-4.08c0-1.25-.58-1.82-1.57-1.82s-1.85.66-1.85,2.08v3.82h-2.24v-7.73h2.14v.91a3.39,3.39,0,0,1,2.56-1C245.21,326.67,246.59,327.73,246.59,330.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.24,331.28h-5.85a2.07,2.07,0,0,0,2.21,1.55,2.59,2.59,0,0,0,1.94-.75l1.2,1.3a4.05,4.05,0,0,1-3.19,1.25c-2.68,0-4.42-1.68-4.42-4a3.93,3.93,0,0,1,4.13-4,3.82,3.82,0,0,1,4,4C256.28,330.85,256.25,331.09,256.24,331.28ZM250.36,330h3.81a1.93,1.93,0,0,0-3.81,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.31,
    cy: 143.52,
    r: 30.05,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,138.05h-.5v-2.8a5.86,5.86,0,0,1,11.72,0v2.28h-.5v-2.28a5.36,5.36,0,0,0-10.72,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.76,157.65h-14.9a2.48,2.48,0,0,1-2.47-2.47V140.27a2.48,2.48,0,0,1,2.47-2.47h14.9a2.48,2.48,0,0,1,2.47,2.47v14.91A2.48,2.48,0,0,1,244.76,157.65Zm-14.9-19.35a2,2,0,0,0-2,2v14.91a2,2,0,0,0,2,2h14.9a2,2,0,0,0,2-2V140.27a2,2,0,0,0-2-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.38,148.21a2.34,2.34,0,1,1,2.34-2.34A2.34,2.34,0,0,1,237.38,148.21Zm0-4.17a1.84,1.84,0,1,0,1.84,1.83A1.84,1.84,0,0,0,237.38,144Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.06,
    y: 147.86,
    width: 0.5,
    height: 4.22,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "446.31 458.77 427.44 415.24 405.79 429.14 428.75 468.93 440.26 463.77 446.31 458.77",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.89,456.34l.62,1.24s25.15-2.15,27.38,1.71L432.25,480l-6.33-14.14C433.54,465.66,440.18,462.76,445.89,456.34Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.34,468.21a1.89,1.89,0,0,0-.21,2.52,1.82,1.82,0,0,0,2.5.23,2,2,0,0,0,.21-2.67,1.9,1.9,0,0,0-2.63,0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.25,480l-1.52-3.4L471.19,458s2.26-.11,2.7,1.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.72,457.62c.09.21-.88.8-1.55,2s-.79,2.27-1,2.28-.51-1.31.33-2.69S446.67,457.41,446.72,457.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,457.25c.15.18-.56,1-.82,2.16s0,2.22-.22,2.31-.91-1-.55-2.49S451.88,457.06,452,457.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.07,461.24c-.17.14-1-.74-1-2.11s.7-2.29.87-2.16-.12,1-.08,2.14S457.26,461.12,457.07,461.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.82 466.33 411.54 418.88 386.09 422.64 390.63 468.36 403.25 468.39 410.82 466.33",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.43,463.94l.07,1.38s23.8,8.4,24.24,12.83l-46.48,1.74.05-15.49C396.34,467.34,403.59,467.43,411.43,463.94Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.2,469.17a1.91,1.91,0,0,0-1.23,2.22,1.83,1.83,0,0,0,2.19,1.24,2,2,0,0,0,1.29-2.36,1.89,1.89,0,0,0-2.42-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.26,479.89v-3.72l44.54-.31s2.11.82,1.93,2.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.66,465.44c0,.23-1.13.38-2.22,1.15s-1.64,1.74-1.86,1.66.08-1.4,1.41-2.31S411.7,465.23,411.66,465.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.61,467.28c.06.21-.9.64-1.64,1.63s-.92,2-1.15,2-.41-1.28.52-2.5S416.6,467.06,416.61,467.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6,473c-.2.05-.56-1.07,0-2.33s1.58-1.8,1.69-1.62-.53.88-1,1.92S419.83,473,419.6,473Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.51,272.89l-.95-37.36-36.36,1.91L354,241.86a200.41,200.41,0,0,0-4.76,20.8c-2.44,15.65-2.15,29.89,4,46.62S369,357.82,369,357.82l36.07,99.63,42-13.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.5,234.32l3.17,10.35c4.66,3,12.19,17.7,12.88,23.72s2,26.63.63,50.79c-1.17,19.87-11,136.17-11,136.17l-39.74,2.1,4.14-188.06,1.75-33.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.4,266.1a6.4,6.4,0,0,0,1.38.41,22.82,22.82,0,0,0,3.87.52,25.25,25.25,0,0,0,22.23-11,21.74,21.74,0,0,0,1.93-3.4,6,6,0,0,0,.51-1.34c-.1-.05-.85,1.87-2.76,4.52a26.07,26.07,0,0,1-21.89,10.85A52.31,52.31,0,0,1,346.4,266.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,246.12a2.73,2.73,0,0,0,.23.87,18.86,18.86,0,0,0,.92,2.24,29,29,0,0,0,10.48,11.9,19.56,19.56,0,0,0,2.11,1.19,3,3,0,0,0,.83.34c.05-.09-1.06-.69-2.72-1.86a33.08,33.08,0,0,1-10.35-11.74C413.53,247.27,413.07,246.09,413,246.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.27,277.88s.1.25.27.77l.73,2.29c.64,2,1.57,5,2.76,8.81,2.38,7.68,5.82,18.76,10.07,32.45,8.62,27.36,19.57,65.47,34.25,106.72q2.52,7.41,5,14.63l.08.26-.25.08-42,13.79-.23.08-.08-.23-24.15-67-6.87-19.19c-.79-2.22-1.39-3.94-1.81-5.11q-.3-.86-.45-1.32l-.15-.45s.07.14.18.44.28.74.5,1.3l1.88,5.08c1.63,4.47,4,11,7,19.15l24.32,66.9-.3-.15,42-13.82-.17.33q-2.46-7.22-5-14.63c-14.68-41.26-25.57-79.38-34.1-106.77-4.18-13.72-7.56-24.82-9.91-32.5-1.15-3.84-2.05-6.81-2.66-8.85-.3-1-.53-1.77-.68-2.3S394.27,277.88,394.27,277.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,169.45s-1.9-10.63-7.35-15.72-28.16-10.85-28.16-10.85.27,7.89-4.81,10c-5.38,2.25-10.76,1.49-15-3a21.74,21.74,0,0,1-5.17-9.89s-26.92,3.93-30.75,11.23-7.84,35-7.84,35l24.39,3.85-.79,47.38,64.1-3.37L415,189.87l17.58,1.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.17,191.4a4.89,4.89,0,0,0,0-1.06c0-.69-.06-1.68-.13-2.91-.13-2.44-.34-5.82-.62-9.55s-.55-7.11-.78-9.55c-.12-1.22-.22-2.21-.3-2.89a4,4,0,0,0-.19-1.05,3.67,3.67,0,0,0,0,1.06c0,.69.06,1.68.13,2.9.13,2.45.34,5.83.62,9.56s.55,7.11.78,9.55c.11,1.22.22,2.21.3,2.89A3.51,3.51,0,0,0,360.17,191.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.86,168.77c-.15,0-1.4,4.83-2.8,10.87a112.23,112.23,0,0,0-2.26,11,111.21,111.21,0,0,0,2.8-10.87A112.23,112.23,0,0,0,419.86,168.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.34,149.42c0,.1,1.16.25,3,.83a21.25,21.25,0,0,1,6.46,3.42,21.58,21.58,0,0,1,4.89,5.44c1,1.61,1.42,2.71,1.52,2.67a2.71,2.71,0,0,0-.23-.8,13.94,13.94,0,0,0-.95-2.07,19.2,19.2,0,0,0-11.58-9,12.93,12.93,0,0,0-2.23-.43A2.38,2.38,0,0,0,341.34,149.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.16,155.87a11.22,11.22,0,0,0-1,3.39,11.2,11.2,0,0,0-.41,3.49,11.44,11.44,0,0,0,.95-3.38A11.25,11.25,0,0,0,423.16,155.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.24,186.93s9.16,36.31,10.15,39.41,2.77,11.48,11.61,12.76c11.94,1.74,58.24-2.35,58.24-2.35l-9.33-10.62-41.19-9.24-7-26.4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.35,219.9a2.34,2.34,0,0,0-.3.87,11.59,11.59,0,0,0-.34,2.47,14.11,14.11,0,0,0,2.08,7.9,16.19,16.19,0,0,0,2.85,3.54,9,9,0,0,0,3.2,1.9,8.82,8.82,0,0,0,2.47.42,2.32,2.32,0,0,0,.91-.08,18.06,18.06,0,0,1-3.24-.71,9,9,0,0,1-3-1.91,17.36,17.36,0,0,1-2.72-3.45,14.86,14.86,0,0,1-2.16-7.61C406.09,221.18,406.45,219.92,406.35,219.9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.88,182.57a5.22,5.22,0,0,1-1.1-.11l-3-.43c-2.5-.36-6-.77-9.79-1.27a97.74,97.74,0,0,1-9.75-1.69c-1.23-.3-2.22-.57-2.89-.79a4.66,4.66,0,0,1-1-.38c0-.09,1.54.31,4,.8s5.92,1,9.74,1.53,7.29,1,9.78,1.42c1.25.23,2.25.44,2.94.61A3.88,3.88,0,0,1,359.88,182.57Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,170.48a3.71,3.71,0,0,1-.94.05c-.61,0-1.49,0-2.58-.08-2.17-.11-5.17-.35-8.47-.76s-6.27-.92-8.4-1.35c-1.07-.22-1.93-.41-2.52-.56a2.78,2.78,0,0,1-.9-.28,24.88,24.88,0,0,1,3.49.47c2.14.33,5.11.78,8.39,1.19s6.27.71,8.44.91A24.17,24.17,0,0,1,358,170.48Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.91,161.28a12.45,12.45,0,0,1-2.85,0,58.77,58.77,0,0,1-13.49-2.53,13.25,13.25,0,0,1-2.67-1,17.09,17.09,0,0,1,2.77.65c1.69.44,4.05,1,6.67,1.5s5,.81,6.76,1A17.93,17.93,0,0,1,355.91,161.28Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,148.17a19.83,19.83,0,0,1-3.22,1c-2,.52-4.79,1.16-7.88,1.78s-5.92,1.09-8,1.39a19.08,19.08,0,0,1-3.34.35,23.35,23.35,0,0,1,3.27-.72l7.92-1.54,7.91-1.63A21.67,21.67,0,0,1,373,148.17Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.69,159a5.61,5.61,0,0,1-1.14-.4l-3.06-1.26c-2.57-1.06-6.13-2.53-10.09-4.08s-7.57-2.88-10.19-3.84l-3.09-1.14a5.05,5.05,0,0,1-1.12-.49,5.58,5.58,0,0,1,1.18.29c.76.21,1.83.55,3.16,1,2.65.87,6.29,2.15,10.26,3.7s7.51,3.07,10,4.23c1.27.58,2.29,1.06,3,1.41A5.34,5.34,0,0,1,422.69,159Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.86,168.32a2.86,2.86,0,0,1-.62-.07l-1.78-.28-6.5-1.14c-5.49-1-13.08-2.29-21.52-3.31-4.22-.49-8.25-.84-11.93-1.06s-7-.27-9.77-.22c-1.39,0-2.65.06-3.76.09s-2.05.07-2.83.13l-1.79.09a2.78,2.78,0,0,1-.63,0,2.82,2.82,0,0,1,.62-.1l1.78-.19c.78-.09,1.73-.17,2.84-.22s2.37-.16,3.76-.17c2.79-.09,6.12-.05,9.81.11s7.73.53,12,1c8.45,1,16,2.41,21.52,3.47,2.73.53,5,1,6.47,1.3l1.76.39A2.39,2.39,0,0,1,419.86,168.32Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,184.66a7.49,7.49,0,0,1-1.37,0c-.89-.05-2.16-.16-3.74-.32-3.14-.33-7.48-.9-12.23-1.77s-9-1.86-12.07-2.66c-1.53-.41-2.76-.75-3.6-1a7.57,7.57,0,0,1-1.3-.45,6,6,0,0,1,1.35.25l3.64.85c3.08.71,7.34,1.64,12.08,2.51s9.05,1.49,12.18,1.91l3.71.5A6.42,6.42,0,0,1,394,184.66Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.75,185a99.16,99.16,0,0,1-10.17.36,100.58,100.58,0,0,1-10.16-.17,95.38,95.38,0,0,1,10.16-.36A94.34,94.34,0,0,1,415.75,185Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.18,199.36a4.08,4.08,0,0,1-1.11-.05c-.7-.06-1.73-.19-3-.37-2.52-.36-6-1-9.77-1.85s-7.16-1.88-9.57-2.67c-1.21-.4-2.18-.74-2.85-1a4.76,4.76,0,0,1-1-.44,4.08,4.08,0,0,1,1.08.24l2.89.84c2.43.7,5.81,1.62,9.58,2.51s7.21,1.55,9.71,2l3,.54A4.36,4.36,0,0,1,387.18,199.36Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.73,200.4a16.16,16.16,0,0,1-3.22,0c-2-.07-4.73-.27-7.74-.66s-5.72-.9-7.66-1.33a16.23,16.23,0,0,1-3.1-.86,21,21,0,0,1,3.18.49c1.95.34,4.65.78,7.65,1.17s5.72.65,7.69.82A22.74,22.74,0,0,1,410.73,200.4Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.82,213.46a1.34,1.34,0,0,1-.41.17c-.27.08-.67.22-1.2.36a38.77,38.77,0,0,1-4.5.93,58.45,58.45,0,0,1-15.13.13,116.65,116.65,0,0,1-14.89-2.79c-1.88-.46-3.39-.86-4.44-1.15a8.92,8.92,0,0,1-1.61-.5,12.34,12.34,0,0,1,1.66.3l4.48,1a144.34,144.34,0,0,0,14.85,2.63,64.14,64.14,0,0,0,15,0c1.91-.24,3.45-.53,4.51-.76A11.68,11.68,0,0,1,405.82,213.46Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93,175.93a31.8,31.8,0,0,1-5.07.41,19.77,19.77,0,0,1-5.1-.12,31.8,31.8,0,0,1,5.07-.41A19.77,19.77,0,0,1,428.93,175.93Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.58,163.75a14.33,14.33,0,0,1-5.53-.36,14.87,14.87,0,0,1,5.53.36Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.24,200.23c-.05-.09,1.05-.64,2.55-1.88a18.28,18.28,0,0,0,2.38-2.42,18.27,18.27,0,0,0,3.59-7.43,18.07,18.07,0,0,0,.41-3.38c.05-1.94-.21-3.14-.11-3.16a2.67,2.67,0,0,1,.24.83,6.77,6.77,0,0,1,.16,1,12.67,12.67,0,0,1,.09,1.33,16.1,16.1,0,0,1-.31,3.48,17.31,17.31,0,0,1-3.69,7.64,15.9,15.9,0,0,1-2.53,2.41,11,11,0,0,1-1.1.76,6.93,6.93,0,0,1-.88.49A2.57,2.57,0,0,1,385.24,200.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M393.81,190.49l-3.89,5.78a18.45,18.45,0,0,1-10.42,6.49,10.89,10.89,0,0,0,14.31-12.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M405.34,130.24a19.3,19.3,0,0,0,10.73-2.18c-4.84-3-7.89-8.26-9.37-13.75s-3.38-14.85-3.43-20.53l-8.86,39.37a23.77,23.77,0,0,0,14-1.09A3.86,3.86,0,0,1,405.34,130.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.06,135a27.7,27.7,0,0,1-2.14-14.07l-17.86-6.77a31.44,31.44,0,0,1-5.7,13.42c-1.09,1.48-2.39,3.2-1.88,5a3.76,3.76,0,0,0,2.77,2.37,11.27,11.27,0,0,0,3.8,0l-2.28,2.49A137,137,0,0,1,380.06,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.57,76.16c-5.63-.58-10.39,1.89-14.88,5.33a28,28,0,0,0-9.42,13.82,27.75,27.75,0,0,0,.12,17.58,22.13,22.13,0,0,0,11.77,12.82c7.48,3.2,16.67,1.31,22.83-4s9.33-13.67,9.11-21.82a26.87,26.87,0,0,0-5.29-15.68,20.5,20.5,0,0,0-14.24-8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,96.14c.67-2.18.2-4.54.37-6.82.39-5,4.14-9.27,8.64-11.51,4.2-2.09,9.49-2,14.79-.7a19.82,19.82,0,0,1,9.68,5.44,15.62,15.62,0,0,1,3.79,13.84l-25.69-2a28.33,28.33,0,0,1-7.38,5.58,5.25,5.25,0,0,1-2.62.6A2.39,2.39,0,0,1,366.46,99C366.16,98.08,366.67,97.09,367,96.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.78,84.1l-21.91,6.16a4.16,4.16,0,0,0-3.61,4.31l3.42,48.07a15,15,0,0,0,3.72,8.86l2.3,2.59c5.24,5.92,15,4.65,18.22-2.56a5.29,5.29,0,0,0,.42-1.29,8.07,8.07,0,0,0,.14-1.1,34.84,34.84,0,0,0-.09-7.31c-.06-4.29-.11-6.05-.11-6s9-1.75,10.58-13.61c.78-5.91.23-15.53-.48-23.4C403.75,91.74,398.82,83.16,391.78,84.1Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.17,106.38a1.53,1.53,0,0,1-1.43,1.57,1.44,1.44,0,0,1-1.59-1.32,1.51,1.51,0,0,1,1.41-1.57A1.45,1.45,0,0,1,400.17,106.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.43,103.88c-.19.2-1.36-.62-3-.57s-2.8.9-3,.7.09-.45.6-.84a4.14,4.14,0,0,1,2.38-.8,4,4,0,0,1,2.39.7C402.34,103.44,402.52,103.79,402.43,103.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.73,107.19a1.52,1.52,0,0,1-1.42,1.57,1.45,1.45,0,0,1-1.6-1.32,1.52,1.52,0,0,1,1.42-1.57A1.45,1.45,0,0,1,384.73,107.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,104.61c-.18.2-1.35-.61-3-.57s-2.8.9-3,.7.09-.44.61-.84a4.14,4.14,0,0,1,2.38-.8,4,4,0,0,1,2.38.7C386.31,104.17,386.49,104.52,386.4,104.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,116.55a10.7,10.7,0,0,1,2.64-.55c.42,0,.81-.15.87-.43a2.16,2.16,0,0,0-.31-1.23l-1.32-3.14c-1.83-4.47-3.16-8.15-3-8.22s1.81,3.49,3.64,8l1.26,3.16a2.39,2.39,0,0,1,.26,1.63,1,1,0,0,1-.67.63,2.73,2.73,0,0,1-.7.11A10.57,10.57,0,0,1,392.64,116.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.28,135.82a30.1,30.1,0,0,1-15.93-3.8s4.19,8.07,16,6.65Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.06,120.5a2.93,2.93,0,0,0-2.66-1,2.64,2.64,0,0,0-1.83,1,1.72,1.72,0,0,0-.08,2,2,2,0,0,0,2.15.48,6.14,6.14,0,0,0,2.06-1.3,2.08,2.08,0,0,0,.45-.49.56.56,0,0,0,0-.61",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.88,117.8c.26,0,.31,1.75,1.86,3s3.43,1,3.45,1.22-.41.35-1.21.39a4.42,4.42,0,0,1-2.88-.91,3.82,3.82,0,0,1-1.44-2.49C387.57,118.24,387.75,117.8,387.88,117.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.55,99.67c-.15.45-1.79.28-3.69.57s-3.44.84-3.71.45c-.12-.19.14-.61.75-1.06a6.34,6.34,0,0,1,2.73-1,6.23,6.23,0,0,1,2.91.27C386.25,99.12,386.61,99.46,386.55,99.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.76,96.76c-.27.38-1.41,0-2.76,0s-2.49.32-2.76-.06c-.12-.19.05-.56.54-.93a4,4,0,0,1,4.45,0C401.72,96.2,401.89,96.58,401.76,96.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.67,93c1.86-6.92,11.31-16.79,18.47-16.62l11.71,6.32a11,11,0,0,1-7.08,8.75c-2,.71-4.4,1-5.52,2.77s-.31,4.37-1.37,6.25c-1.46,2.6-5.78,2.68-6.84,5.47-.47,1.21-.13,2.63-.62,3.84-.64,1.61-4.55,3.8-6.23,3.35s-1.81-3.27-2.42-4.72a7.82,7.82,0,0,1-.48-5.23C362.86,99.8,361.78,96.28,362.67,93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.14,114.28c0-.88-1.1-2.93-2-3-2.33-.3-6.5,0-6.39,5.89.17,8.06,8.22,6.24,8.23,6S370.22,117.32,370.14,114.28Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.48,120.13s-.14.1-.37.22a1.41,1.41,0,0,1-1.05,0c-.86-.29-1.6-1.63-1.67-3.08a4.53,4.53,0,0,1,.35-2,1.6,1.6,0,0,1,1-1.1.71.71,0,0,1,.84.37c.11.22.07.38.11.4s.17-.14.1-.47a.93.93,0,0,0-.33-.5,1,1,0,0,0-.78-.19,2,2,0,0,0-1.44,1.28,4.7,4.7,0,0,0-.44,2.25c.08,1.63.94,3.13,2.11,3.44a1.48,1.48,0,0,0,1.28-.24C367.47,120.33,367.51,120.15,367.48,120.13Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.81,91h0c-.14-2.52-3.38-4-5.87-4.37a10.49,10.49,0,0,0-7.15,1.86c-1.24.79-2.48,1.88-2.67,3.34s1.31,3.09,2.65,2.48a4.78,4.78,0,1,0,5.15,7.85,10.68,10.68,0,0,1-3.81,6A12,12,0,0,0,360.81,91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.78,125.52c0-.38,1.05-.56,2.48-1a15,15,0,0,0,5.05-2.5,14.88,14.88,0,0,0,3.65-4.3c.77-1.29,1.18-2.22,1.56-2.16s.6,1.13.2,2.85a10.73,10.73,0,0,1-10.21,8C347.74,126.38,346.74,125.87,346.78,125.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.07,104.15a7.15,7.15,0,0,1-.46-2.39,17.81,17.81,0,0,1,3-11.22,7.16,7.16,0,0,1,1.59-1.85A26.74,26.74,0,0,0,356.67,96,27,27,0,0,0,356.07,104.15Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36,80.4c.95,3.22,6.2,7.09,8.55,9.5,4.48,4.58,5.41,6.14,6.08,17,1.72-3.88,3-7.66,2.55-11.88a17.62,17.62,0,0,0-5.4-11.22,13.71,13.71,0,0,0-11.78-3.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.9,174.43s-5.38,22.36-7.59,32C433,216.7,427.86,240,414.22,236.6c-10.38-2.56-8.07-16-8.07-16L415,189.87l8.2.93,7.53-18.54,8.12-8.55Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.77,221.4a11.49,11.49,0,0,1-.27-5,15.74,15.74,0,0,1,1.92-5.06,44.12,44.12,0,0,1,4-5.42,43.09,43.09,0,0,0,4-5.51,33.48,33.48,0,0,0,2.42-5,30.87,30.87,0,0,0,1.12-3.57,6,6,0,0,0,.25-1.35,8.63,8.63,0,0,0-.46,1.29c-.27.83-.67,2-1.28,3.48a37.17,37.17,0,0,1-2.49,4.89,47.32,47.32,0,0,1-4,5.42,40.8,40.8,0,0,0-4,5.52,15.3,15.3,0,0,0-1.87,5.25,9.72,9.72,0,0,0,.16,3.76,6.58,6.58,0,0,0,.33,1C409.69,221.3,409.75,221.41,409.77,221.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.1,174c0-.4.2-6.91.33-8.61a8.8,8.8,0,0,1,.89-3.09,2.62,2.62,0,0,1,4.08-.72l.15.13a11.5,11.5,0,0,1,3.21-3.87c1.91-1.25,3.48-2.1,5.12-1.12a2.85,2.85,0,0,1,1.58,2.37s2.43-.33,3.48.65,0,3.94,0,3.94,2.16-.66,2.69.92a4.39,4.39,0,0,1-.46,3.22s1.7.52,1.9,1.77-1.7,2.62-1.7,2.62l-5.93,4.72a11.29,11.29,0,0,1-4.57,6C436.75,184.51,430.1,174,430.1,174Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.62,166.91c.06,0,.05.25-.13.55a2,2,0,0,1-1,.88,2.14,2.14,0,0,1-1.36,0c-.33-.11-.49-.27-.46-.34s.81.11,1.63-.21S434.48,166.84,434.62,166.91Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.32,161.09c-.09.12-.66-.28-.76-1.06s.33-1.31.45-1.22,0,.57.08,1.15S439.43,161,439.32,161.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.23,163.62s-.42.61-1.31,1.38a38.6,38.6,0,0,1-3.69,2.7,5.67,5.67,0,0,1-2.36,1.1,2.13,2.13,0,0,1-2-.75,1.48,1.48,0,0,1-.16-1.46c.16-.32.36-.4.38-.37s-.11.16-.19.45a1.36,1.36,0,0,0,.27,1.16,1.8,1.8,0,0,0,1.67.48,5.63,5.63,0,0,0,2.13-1.05c1.49-1,2.82-1.87,3.75-2.56A9.59,9.59,0,0,1,449.23,163.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.13,167.79a37.75,37.75,0,0,1-5.65,2.88,5.77,5.77,0,0,1-2.45.72,1.93,1.93,0,0,1-1.84-1.1,1.12,1.12,0,0,1,0-.88,1.05,1.05,0,0,1,.43-.49c.33-.18.54-.08.53-.06s-.19,0-.41.23a.85.85,0,0,0-.19,1,1.54,1.54,0,0,0,1.49.75,5.75,5.75,0,0,0,2.23-.71A38.82,38.82,0,0,1,451.13,167.79Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.25,173.12c0,.06-.32.31-1,.47a4.61,4.61,0,0,1-1.18.12,3.16,3.16,0,0,1-1.47-.33.9.9,0,0,1-.43-.85,1.41,1.41,0,0,1,.32-.73,5,5,0,0,1,.85-.83c.54-.4.94-.53,1-.47s-.28.31-.72.76a6.2,6.2,0,0,0-.7.83c-.23.33-.31.67,0,.84a3.21,3.21,0,0,0,1.21.29,5.64,5.64,0,0,0,1.09,0C447.84,173.16,448.22,173.05,448.25,173.12Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.62,174.11a4.84,4.84,0,1,0-6.14,4.49l-.05,1.35,1.32,1-1.39.78-.06,1.69,1.32,1-1.39.78-.05,1.45.8.6-.84.47,0,.85,1,1.14,2-1.19.38-10A4.85,4.85,0,0,0,442.62,174.11Zm-4.71-3.72a1.39,1.39,0,1,1-1.44,1.34A1.39,1.39,0,0,1,437.91,170.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.62,174.11a4.84,4.84,0,1,0-6.14,4.49l-.05,1.35,1.32,1-1.39.78-.06,1.69,1.32,1-1.39.78-.05,1.45.8.6-.84.47,0,.85,1,1.14,2-1.19.38-10A4.85,4.85,0,0,0,442.62,174.11Zm-4.71-3.72a1.39,1.39,0,1,1-1.44,1.34A1.39,1.39,0,0,1,437.91,170.39Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,170.39s-.12,0-.33.06a1.39,1.39,0,0,0-.76.48A1.34,1.34,0,1,0,439,171a1.41,1.41,0,0,0-.72-.54c-.2-.06-.33-.06-.33-.08H438a1,1,0,0,1,.26,0,1.38,1.38,0,0,1,.77.53,1.43,1.43,0,0,1,.17,1.37,1.39,1.39,0,0,1-.53.65,1.43,1.43,0,0,1-.86.25,1.47,1.47,0,0,1-.85-.31,1.5,1.5,0,0,1-.48-.7,1.47,1.47,0,0,1,.27-1.35,1.43,1.43,0,0,1,.82-.47,1.29,1.29,0,0,1,.25,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.62,174.11v.1l0,.29a4.91,4.91,0,0,1-.24,1.08,4.75,4.75,0,0,1-.9,1.54,4.8,4.8,0,0,1-2,1.38l0,0c-.1,2.59-.22,6-.36,10v0h0l-2,1.2,0,0,0,0-1-1.14v0c0-.27,0-.56,0-.85v0l0,0,.84-.47v.1l-.81-.61,0,0v0c0-.45,0-1,.05-1.45v0l0,0,1.39-.77v.1l-1.32-1h0V183c0-.42,0-.83.05-1.24v0h0l1.39-.78v.1l-1.32-1,0,0v0c0-.46,0-.91.05-1.35l0,.06a5,5,0,0,1-2-1.12,4.5,4.5,0,0,1-.73-.85,4.85,4.85,0,0,1-.29-5,4.86,4.86,0,0,1,8.05-.89,4.7,4.7,0,0,1,.93,1.71l.06.18,0,.18c0,.12.05.22.06.33s.05.37.05.51V174a.36.36,0,0,1,0,.1v-.42c0-.14,0-.31-.06-.51a2.06,2.06,0,0,0-.07-.32l0-.18-.06-.18a4.6,4.6,0,0,0-.93-1.68,4.89,4.89,0,0,0-2.11-1.44,4.8,4.8,0,0,0-6,6.29,4.55,4.55,0,0,0,.5,1,4.38,4.38,0,0,0,.72.83,4.76,4.76,0,0,0,1.95,1.09l.05,0v0c0,.45,0,.9-.05,1.35l0,0,1.33,1,.07,0-.08.05-1.39.77,0-.05c0,.41,0,.83,0,1.24l0,.45,0,0,1.32,1,.07.06-.08,0-1.39.78,0,0c0,.5,0,1-.05,1.45l0,0,.81.6.07.06-.08,0-.84.48,0,0c0,.29,0,.58,0,.84v0l1,1.14h-.07l2-1.19,0,.05c.16-4,.29-7.44.39-10v0h0a4.82,4.82,0,0,0,1.94-1.34,5,5,0,0,0,.9-1.52,5.21,5.21,0,0,0,.26-1.08l0-.28A.67.67,0,0,0,442.62,174.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.12,173.84a4.85,4.85,0,1,0-6.14,4.49h0l-.05,1.34,1.32,1-1.39.77-.06,1.69,1.32,1-1.39.77-.06,1.45.81.61-.85.47,0,.84,1,1.14,2-1.19.38-10A4.84,4.84,0,0,0,442.12,173.84Zm-4.71-3.72a1.39,1.39,0,0,1,1.34,1.44,1.39,1.39,0,1,1-2.78-.11A1.39,1.39,0,0,1,437.41,170.12Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.12,173.84a4.85,4.85,0,1,0-6.14,4.49h0l-.05,1.34,1.32,1-1.39.77-.06,1.69,1.32,1-1.39.77-.06,1.45.81.61-.85.47,0,.84,1,1.14,2-1.19.38-10A4.84,4.84,0,0,0,442.12,173.84Zm-4.71-3.72a1.39,1.39,0,0,1,1.34,1.44,1.39,1.39,0,1,1-2.78-.11A1.39,1.39,0,0,1,437.41,170.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.41,170.12a3.42,3.42,0,0,0-.34,0,1.37,1.37,0,0,0-.75.48,1.33,1.33,0,0,0-.23,1.26,1.35,1.35,0,0,0,1.22.93,1.37,1.37,0,0,0,1.28-.83,1.35,1.35,0,0,0-.85-1.81,3.34,3.34,0,0,0-.33-.08h.09a1,1,0,0,1,.25,0,1.36,1.36,0,0,1,.78.53,1.44,1.44,0,0,1-.36,2,1.44,1.44,0,0,1-.87.25,1.47,1.47,0,0,1-.84-.32A1.36,1.36,0,0,1,436,172a1.43,1.43,0,0,1,1.08-1.83.79.79,0,0,1,.26,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.12,173.84v.1l0,.28a5.09,5.09,0,0,1-.24,1.09,5.17,5.17,0,0,1-.9,1.54,5,5,0,0,1-2,1.38l0,0c-.09,2.59-.21,6-.35,10v0l0,0-2,1.19,0,0,0,0-1-1.14,0,0v0c0-.26,0-.55,0-.84v0h0l.84-.48v.1l-.8-.6,0,0v0c0-.46,0-.95.05-1.45v0h0l1.39-.78v.1l-1.32-1,0,0v0l0-.45c0-.41,0-.83.05-1.24v0l0,0,1.39-.77v.1l-1.32-1,0,0v0c0-.45,0-.9.05-1.35l0,.06a4.76,4.76,0,0,1-2-1.12,4.61,4.61,0,0,1-.74-.85,4.74,4.74,0,0,1-.51-1,4.9,4.9,0,0,1,3-6.41,5,5,0,0,1,3.16,0A4.94,4.94,0,0,1,441,170.5a4.86,4.86,0,0,1,.93,1.71l.06.19,0,.18c0,.11.05.22.06.32s.05.38.05.51v.43a.87.87,0,0,0,0-.11v-.31c0-.14,0-.31-.05-.52s-.05-.2-.07-.32l0-.17-.06-.19a4.8,4.8,0,0,0-.94-1.68,4.73,4.73,0,0,0-2.11-1.43,4.83,4.83,0,0,0-3.1,0,4.89,4.89,0,0,0-2.7,2.33,4.83,4.83,0,0,0-.22,3.95,5.2,5.2,0,0,0,.51,1,4.34,4.34,0,0,0,.72.83,4.81,4.81,0,0,0,1.95,1.09H436v.05c0,.44,0,.89,0,1.35l0-.05c.44.32.88.66,1.32,1l.08.06-.08,0-1.39.78,0-.05c0,.41,0,.82-.05,1.24,0,.15,0,.3,0,.44l0,0,1.32,1,.08,0-.08.05-1.39.77,0,0c0,.5,0,1-.06,1.45l0,0,.81.61.07.05-.08,0-.85.47,0,0c0,.29,0,.58,0,.84v0l1,1.15-.07,0,2-1.19,0,.05c.15-4,.29-7.44.39-10v0h0a5,5,0,0,0,1.95-1.35,5.19,5.19,0,0,0,.9-1.52,5,5,0,0,0,.26-1.07l0-.29A.31.31,0,0,1,442.12,173.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.54,173.88a6.59,6.59,0,0,0-.12-1,3.88,3.88,0,0,0-.43-1.14,4.19,4.19,0,0,0-1-1.24,4.17,4.17,0,0,0-4-.74,3.93,3.93,0,0,0-1.09.53,4.41,4.41,0,0,0-.49.39,4.79,4.79,0,0,0-.43.47,4.2,4.2,0,0,0-.19,5,6.4,6.4,0,0,0,.4.51,4.58,4.58,0,0,0,.46.42,3.79,3.79,0,0,0,1,.61,4.27,4.27,0,0,0,2.21.27,4.08,4.08,0,0,0,1.8-.71,4.4,4.4,0,0,0,1.13-1.16,4.28,4.28,0,0,0,.51-1.11,6.59,6.59,0,0,0,.2-1v.28c0,.09,0,.2,0,.33s-.05.27-.1.44a3.9,3.9,0,0,1-.51,1.13,4.33,4.33,0,0,1-1.13,1.19,4.23,4.23,0,0,1-1.84.74,4.36,4.36,0,0,1-2.26-.26,4,4,0,0,1-1.07-.63,6.42,6.42,0,0,1-.48-.43,4,4,0,0,1-.4-.52,4.29,4.29,0,0,1,.19-5.11,5.12,5.12,0,0,1,.44-.49,4.6,4.6,0,0,1,.51-.39,4.22,4.22,0,0,1,3.39-.64,4.14,4.14,0,0,1,1.78.88,4.28,4.28,0,0,1,1,1.27,4.35,4.35,0,0,1,.42,1.16,2.8,2.8,0,0,1,.06.45,2.06,2.06,0,0,1,0,.33v.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,171.58a3.49,3.49,0,0,0-.06-.39,1.52,1.52,0,0,0-.56-.89,1.63,1.63,0,0,0-.66-.32,1.58,1.58,0,0,0-.83.05,1.47,1.47,0,0,0-.75.52,1.53,1.53,0,0,0-.33.91,1.56,1.56,0,0,0,1,1.52,1.63,1.63,0,0,0,1.51-.16,1.61,1.61,0,0,0,.62-.85,2.93,2.93,0,0,0,.09-.39s0,0,0,.11a1.53,1.53,0,0,1-.05.3,1.63,1.63,0,0,1-.62.9,1.66,1.66,0,0,1-.72.29,1.67,1.67,0,0,1-1.64-.71,1.67,1.67,0,0,1-.3-1,1.72,1.72,0,0,1,.37-1,1.64,1.64,0,0,1,.81-.55,1.59,1.59,0,0,1,.89,0,1.72,1.72,0,0,1,.69.34,1.61,1.61,0,0,1,.55,1,1.14,1.14,0,0,1,0,.3C439,171.55,439,171.58,439,171.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,188.45s0-2.29.13-5.1.22-5.1.25-5.1,0,2.28-.13,5.1S438,188.45,438,188.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.83,170.6a.74.74,0,0,1-.65,0v-6.15l.65.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.5,170.7a.8.8,0,0,1-.33-.08h0v-6.19l.7.05v6.14h0A.81.81,0,0,1,437.5,170.7Zm-.29-.12a.68.68,0,0,0,.59,0v-6.06l-.6,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,161.43a14.52,14.52,0,0,0,1.73,1.27,2.34,2.34,0,0,1,1.06,1.79,2.19,2.19,0,0,1-1.28,1.69,4,4,0,0,1-5.42-1.63",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.13,164.55a10.79,10.79,0,0,0,1.36,1.22,3.91,3.91,0,0,0,1.8.6,4,4,0,0,0,2.24-.49,1.71,1.71,0,0,0,1-1.74,2.83,2.83,0,0,0-1.11-1.45c-.95-.64-1.48-1.2-1.4-1.26s.59.37,1.61.95A3,3,0,0,1,438,164a1.82,1.82,0,0,1-.21,1.34,2.87,2.87,0,0,1-1,1,4.27,4.27,0,0,1-2.56.52,4.07,4.07,0,0,1-2-.78C431.3,165.33,431.08,164.56,431.13,164.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.16,158.88a23.7,23.7,0,0,0-3,4.4,3.64,3.64,0,0,0-.45,1.57,1.58,1.58,0,0,0,.73,1.4,1.6,1.6,0,0,0,1.37,0,4.31,4.31,0,0,0,1.14-.81,28.08,28.08,0,0,0,3.72-4.14,3.88,3.88,0,0,0,.66-1.17,1.61,1.61,0,0,0-.08-1.31",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.26,158.81s.25.2.28.74a3.19,3.19,0,0,1-.82,2,21.77,21.77,0,0,1-2,2.46c-.4.44-.84.89-1.31,1.33a5,5,0,0,1-1.7,1.22,1.88,1.88,0,0,1-1.15,0,1.53,1.53,0,0,1-.88-.75,2.45,2.45,0,0,1,0-2,12.82,12.82,0,0,1,1.6-2.77,11.52,11.52,0,0,1,1.9-2.19,23.27,23.27,0,0,1-1.59,2.41,13.67,13.67,0,0,0-1.44,2.71,1.92,1.92,0,0,0,0,1.59,1.11,1.11,0,0,0,1.41.46,4.68,4.68,0,0,0,1.5-1.09c.47-.43.91-.86,1.31-1.28.81-.85,1.49-1.65,2-2.35a3.4,3.4,0,0,0,.92-1.78A3.84,3.84,0,0,0,445.26,158.81Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461,480.17c0,.15-97.17.26-217,.26s-217-.11-217-.26,97.15-.26,217-.26S461,480,461,480.17Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPasswordIcon);
export default __webpack_public_path__ + "static/media/new_password_icon.7acd1414d4226e02ffe48e799689b08f.svg";
export { ForwardRef as ReactComponent };